import type { OperationalErrorOptions } from "./operational";
import { OperationalError } from "./operational";

class AuthorizationError extends OperationalError {
  constructor(options?: OperationalErrorOptions) {
    super(options);
    this.message = "You do not have permission to perform the operation.";
  }
}

export { AuthorizationError };
